/**
 * Bu sekmenin SignalR bağlantı kimliği — HTTP isteklerine `X-Octo-Hub` başlığıyla eklenir.
 *
 * DAL kayıt/silme sonrası "RowsChanged" yayınını yaparken işlemi yapan bağlantıyı hariç
 * tutar: o sekme kendi yenilemesini zaten yapıyor. Ayrı modül, çünkü HTTP istemcisi hub
 * modülünü (o da oturum store'unu, o da HTTP istemcisini) içe aktaramaz.
 */
let current: string | null = null;

export const hubIdentity = {
  get: () => current,
  set: (id: string | null) => {
    current = id;
  },
};
